var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25002 6.80416C-1.60832 14.9667 1.64632e-05 23.6375 1.64632e-05 49.9792C1.64632e-05 71.8542 -3.81665 93.7833 16.1584 98.9458C22.3959 100.55 77.6625 100.55 83.8917 98.9375C92.2084 96.7917 98.975 90.0458 99.9 78.2833C100.029 76.6417 100.029 23.3458 99.8959 21.6708C98.9125 9.14166 91.2 1.92082 81.0375 0.458323C78.7083 0.120823 78.2417 0.0208232 66.2917 -1.01451e-05C23.9042 0.0208232 14.6125 -1.86668 6.25002 6.80416Z",
    fill: "url(#paint0_linear_155_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9917 13.0792C34.8625 13.0792 20.4959 11.7334 15.0084 25.8167C12.7417 31.6334 13.0709 39.1875 13.0709 50.0042C13.0709 59.4959 12.7667 68.4167 15.0084 74.1875C20.4834 88.2792 34.9667 86.9292 49.9834 86.9292C64.4709 86.9292 79.4084 88.4375 84.9625 74.1875C87.2334 68.3125 86.9 60.8709 86.9 50.0042C86.9 35.5792 87.6959 26.2667 80.7 19.275C73.6167 12.1917 64.0375 13.0792 49.975 13.0792H49.9917ZM46.6834 19.7334C78.2417 19.6834 82.2584 16.1751 80.0417 64.9125C79.2542 82.15 66.1292 80.2584 49.9959 80.2584C20.5792 80.2584 19.7334 79.4167 19.7334 49.9875C19.7334 20.2167 22.0667 19.75 46.6834 19.725V19.7334ZM69.7 25.8625C68.5254 25.8625 67.3988 26.3292 66.5681 27.1598C65.7375 27.9904 65.2709 29.117 65.2709 30.2917C65.2709 31.4664 65.7375 32.593 66.5681 33.4236C67.3988 34.2542 68.5254 34.7209 69.7 34.7209C70.8747 34.7209 72.0013 34.2542 72.8319 33.4236C73.6626 32.593 74.1292 31.4664 74.1292 30.2917C74.1292 29.117 73.6626 27.9904 72.8319 27.1598C72.0013 26.3292 70.8747 25.8625 69.7 25.8625ZM49.9917 31.0417C47.5018 31.042 45.0363 31.5327 42.736 32.4858C40.4358 33.4389 38.3457 34.8357 36.5853 36.5966C33.0299 40.1527 31.0328 44.9756 31.0334 50.0042C31.0339 55.0328 33.0321 59.8553 36.5882 63.4106C40.1444 66.966 44.9673 68.9631 49.9959 68.9625C55.0245 68.962 59.8469 66.9639 63.4023 63.4077C66.9577 59.8515 68.9548 55.0287 68.9542 50C68.9537 44.9714 66.9555 40.149 63.3994 36.5936C59.8432 33.0382 55.0203 31.0412 49.9917 31.0417ZM49.9917 37.6959C66.2625 37.6959 66.2834 62.3125 49.9917 62.3125C33.725 62.3125 33.7 37.6959 49.9917 37.6959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_2",
    x1: 6.44177,
    y1: 93.6129,
    x2: 99.3812,
    y2: 13.1749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.605c5502177c2cfae7afa08871e21aa9.svg";
export { ForwardRef as ReactComponent };